/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import NotificationDropdown from "../../components/Dropdowns/NotificationDropdown.js";
import UserDropdown from "../../components/Dropdowns/UserDropdown.js";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";

export default function Sidebar() {

  const [locationPathname, setLocationPathname] = useState(location.pathname);
  const [collapseShow, setCollapseShow] = React.useState("hidden");
  return (
    <>
      <nav className="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-1">
        <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
          {/* Toggler */}
          <button
            className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
            type="button"
            onClick={() => setCollapseShow("bg-white m-2 py-3 px-6")}
          >
            <i className="fas fa-bars"></i>
          </button>
          {/* Brand */}
          <Link
            className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-flex items-center whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
            to="/"
          >
            <ImageWithBasePath
              lazyLoad={true}
              src="assets/img/new updated logo-01.png"
              className="w-36 md:w-48"
              alt="Logo"
            />
            <span className="ml-3">Uber Travel Agency</span>
          </Link>



          {/* Collapse */}
          <div
            className={
              "md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " +
              collapseShow
            }
          >
            {/* Collapse header */}
            <div className="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200">
              <div className="flex flex-wrap">
                <div className="w-6/12">
                  <Link
                    className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                    to="/"
                  >
                    Uber Travel Agency
                  </Link>
                </div>
                <div className="w-6/12 flex justify-end">
                  <button
                    type="button"
                    className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                    onClick={() => setCollapseShow("hidden")}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
            {/* Form */}
            {/* Divider */}
            <hr className="my-4 md:min-w-full" />
            {/* Heading */}

            {/* Navigation */}

            <ul className="md:flex-col md:min-w-full flex flex-col list-none">
              <li className="items-center pb-3">
                <Link
                  to="/partner/partnerHome"
                  onClick={() => setLocationPathname("/partner/partnerHome")}
                >
                  <i className="fas fa-wallet mr-2 text-sm"></i>
                  Dashboard
                </Link>
              </li>
              <li className="items-center pb-3">
                <Link
                  to="/services"
                  onClick={() => setLocationPathname("/services")}
                >
                  <i
                    className={
                      "fas fa-home mr-2 text-sm "}></i>
                  Booking Services
                </Link>
              </li>
              <li className="items-center pb-3">
                <Link
                  to="/services"
                  onClick={() => setLocationPathname("/services")}
                >
                  <i
                    className={
                      "fas fa-user mr-2 text-sm "}></i>
                  Transactions
                </Link>
              </li>
              <li className="items-center pb-3">
                <Link
                  to="/partner/partnerWallet"
                  onClick={() => setLocationPathname("/partner/partnerWallet")}
                >
                  <i className="fas fa-wallet mr-2 text-sm"></i>
                  My Wallet
                </Link>
              </li>
            </ul>

          </div>
        </div>
      </nav>
    </>
  );
}